import {
    REQUEST_MESSAGES_LIST,
    SET_MESSAGES_LIST,
    SET_PAGE,
    REQUEST_DELETE_MESSAGE,
    SET_MESSAGES_LOADING,
} from './constants'

export function requestMessagesList(page = 1, userFilter, roomFilter, sortBy = 'inserted_at') {
    return {
        type: REQUEST_MESSAGES_LIST,
        payload: {
            page,
            userFilter,
            roomFilter,
            sortBy,
        }
    }
}

export function setMessagesList({ messages, pagination }) {
    return {
        type: SET_MESSAGES_LIST,
        payload: {
            messages,
            pagination
        }
    }
}

export function setPage({ page }) {
    return {
        type: SET_PAGE,
        payload: {
            page
        }
    }
}

export function requestMessageDelete({ messageId, userFilter, roomFilter }) {
    return {
        type: REQUEST_DELETE_MESSAGE,
        payload: {
            messageId,
            userFilter,
            roomFilter
        }
    }
}

export function setMessagesLoading() {
    return {
        type: SET_MESSAGES_LOADING
    }
}
